export default `<svg
  xmlns="http://www.w3.org/2000/svg"
  width="18"
  height="18"
  viewBox="0 0 18 18"
>
  <g
    transform="matrix(0.01757812,0,0,0.01757812,-4.5907525e-4,1.757812e-5)"
  >
    <path
      d="m 512,-0.001 q 57.717,0 98.676,40.96 40.959,40.96 40.96,98.676 10e-4,57.716 -40.96,98.676 -40.961,40.96 -98.676,40.96 -57.715,0 -98.676,-40.96 -40.961,-40.96 -40.96,-98.676 0.001,-57.716 40.96,-98.676 40.959,-40.96 98.676,-40.96 z m 0,372.365 q 57.717,0 98.676,40.96 40.959,40.96 40.96,98.676 10e-4,57.716 -40.96,98.676 -40.961,40.96 -98.676,40.96 -57.715,0 -98.676,-40.96 -40.961,-40.96 -40.96,-98.676 0.001,-57.716 40.96,-98.676 40.959,-40.96 98.676,-40.96 z m 0,372.363 q 57.717,0 98.676,40.96 40.959,40.96 40.96,98.676 10e-4,57.716 -40.96,98.676 -40.961,40.96 -98.676,40.96 -57.715,0 -98.676,-40.96 -40.961,-40.96 -40.96,-98.676 0.001,-57.716 40.96,-98.676 40.959,-40.96 98.676,-40.96 z"
    />
  </g>
</svg>`;
